import Vue from 'vue'
import Router from 'vue-router'
import LandingPage from './pages/LandingPage.vue'
import ModuleSelection from './pages/Modulos.vue'
import presentacion from '@/pages/presentacion/presentacion.vue'
import modulo1 from '@/pages/modulo1/modulo1.vue'
import modulo2 from '@/pages/modulo2/modulo2.vue'
import modulo3 from '@/pages/modulo3/modulo3.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'landingPage',
      component: LandingPage
    },
    {
      path: '/modulos',
      name: 'modulos',
      component: ModuleSelection
    },
    {
      path:'/presentacion/:unipage',
      name:'presentacion',
      component: presentacion
    },
    {
      path:'/modulo1/:unipage',
      name:'modulo1',
      component: modulo1
    },
    {
      path:'/modulo2/:unipage',
      name:'modulo2',
      component: modulo2
    },
    {
      path:'/modulo3/:unipage',
      name:'modulo3',
      component: modulo3
    }
  ]
})
